define('Components/NewsWidget/js/views/NewsListWidgetInstanceView',['jquery','WidgetInstanceView','template!Components/NewsWidget/templates/default','template!Components/NewsWidget/templates/list'],
    function($,WidgetInstanceView,defaultTemplate,listTemplate){
    return WidgetInstanceView.extend({
        name:'NewsListWidgetInstanceView',
        activeSlide: 0,
        events: {
        },
        afterRender: function(){
            var self = this;
            self.listenTo(app,'change:scrollTop',self.onScroll);
        },
        getTemplate:function(){
            switch(this.model.getTemplate()){
                case 'default': default: return defaultTemplate; break;
                case 'list': return listTemplate; break;
            }
        },
        onScroll: function(options){
            var view = this,
                scrollTop = options.get('scrollTop'),
                winH = options.get('winH');
            view.$('.news-list-content').each(function(){
                var $content = $(this),
                    $item = $content.find('.news-list-col.fixed .news-list-item');

                if(scrollTop < $content.offset().top){
                    $item.removeClass('floating bottom');
                }else if(scrollTop + $item.height() > $content.offset().top + $content.height()){
                    $item.removeClass('floating').addClass('bottom');
                }else{
                    $item.removeClass('bottom').addClass('floating');
                }
            })
        }
    })
});
